<template>
  <div class="ma-4" v-if="isAdmin || this.messages.length > 0">
    <v-card class="mx-auto" max-width="800" flat>
      <v-list-item-title class="headline mx-3">{{$t('messages.messages')}} 
        <v-btn v-if="isAdmin" color="success" @click="showDialog({})" class="ma-2">{{ $t('ctrl.add') }}</v-btn>
      </v-list-item-title>

    </v-card>
    
    <v-card class="mx-auto ma-2" min-width="200" max-width="800" v-for="m in messages" v-bind:key="m.id">
      <v-list-item two-line>
        <v-list-item-content >
          <v-list-item-title class="headline"><v-icon v-if="!m.public">mdi-domino-mask</v-icon> {{ m.title }}</v-list-item-title>
          <v-list-item-subtitle>{{ m | interval }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <pre class="mx-3 my-2" style="font-family: sans-serif;">{{ m.text }}</pre>
      <v-divider></v-divider> 

      <v-card-actions>
        <v-btn v-if="m.location" text :href="'https://www.google.com/maps/search/?api=1&query='+m.location" target="_blank">{{ $t('messages.showMap') }}</v-btn>
        <v-btn v-if="isAdmin" text @click="showDialog(m)">{{ $t('ctrl.edit') }}</v-btn>
        <v-btn v-if="isAdmin" text @click="removeMessage(m)" color="red">{{ $t('ctrl.delete') }}</v-btn>
      </v-card-actions>
    </v-card>
    <MessageEditDialog ref="editDialog" :reload="reload" />
    <ConfirmDialog ref="removeDialog" message="messages.confirmRemove" cancel="ctrl.cancel" confirm="ctrl.delete" :onConfirm="confirmRemove" />
  </div>
</template>

<script>
import {
    VIcon,
  } from 'vuetify/lib'
import fccapi from "../../fccapi";
import MessageEditDialog from '../../dialogs/MessageEditDialog'
import ConfirmDialog from '../../dialogs/ConfirmDialog'

export default {
  name: "FCCCompetitionMessages",
  data: function(){
    return {
      messages: []
    };
  },
  methods: {
    showDialog: function(m){
      this.$refs.editDialog.show(m);
    },
    reload: function(){
      fccapi.competitionGet('messages').then((d) => {
        this.messages = d.data
      })
    },
    removeMessage: function(m){
      this.$refs.removeDialog.show(m);
    },
    confirmRemove: function(m){
      fccapi.delete('messages/'+m.id).then(d => {
        this.reload();
      })
    }
  },
  computed: {
    isAdmin: function(){
      return this.$store.getters['isAdministrator'];
    },
    selectedCompetition: function() {
      return this.$store.getters['competitionId'];
    }
  },
  filters: {
    interval: function(v){
      if(v.start == null) return null;
      var re = new RegExp(/(\d\d\d\d)-(\d\d?)-(\d\d?)T(\d\d?):(\d\d?):(\d\d?)?/);
      var r = v.start.match(re);
      var timeValue = r[4] + ":" + r[5];
      var result = r[3] + "." + r[2] + "." + r[1];
      if(timeValue != "00:00"){
        result += " "+timeValue;
      }
      if(v.end != null){
        r = v.end.match(re);
        timeValue = r[4] + ":" + r[5];
        result += " - "+r[3] + "." + r[2] + "." + r[1];
        if(timeValue != "00:00"){
          result += " "+timeValue;
        }
      }
      return result;
    }
  },
  mounted: function() {
    this.reload();
  },
  components: {
    VIcon,
    MessageEditDialog,
    ConfirmDialog
  },
  watch: {
    selectedCompetition() {
      this.reload();
    }
  }
};
</script>